module.exports = __webpack_public_path__ + "static/media/export.37a07c07.svg";